import React from "react";
import { Control } from "@assets/spa/control/text";
export function ForminatorEmail(props) {
    const { placeholder, onChange, onValidate, value, } = props;
    return React.createElement(Control, { value: value || '', onChange: onChange, onBlur: () => { onValidate(value); }, placeholder: placeholder });
}
ForminatorEmail.validate = (value) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);
